import bgPath from '../assets/bg-path.png';
import circlePath from '../assets/circle-path.png';
import iiscLogo from '../assets/iisc-logo.png';
import spareLab from '../assets/spare-lab.png';
import mobilePath from '../assets/mobile-path.png';
import logo from '../assets/logo.png';
import PartnerImg from '../assets/partnerImg.png';
import FFLogo from '../assets/FF-Logo.png';
import GGICImg from '../assets/Giz-German-India-Cooperation.png';
import EmailImg from '../assets/email.png';
import LocationImg from '../assets/location.png';
import DownArrow from '../assets/down-arrow.png';
import UpArrow from '../assets/up-arrow.png';
import MenuImg from '../assets/menu.png';
import CloseImg from '../assets/close.png';
import Menulogo from '../assets/Menulogo.png';
import Syspin from '../assets/Syspin.png';
import Dash from '../assets/Dash.png';
import IISCImg from '../assets/IISC.png';
import rightImg from '../assets/right-arrow.png'; 
import rightarrow from '../assets/right-arrow.png';
import Modelreleased from '../assets/ModelReleased.png';
import Datareleased from '../assets/DataReleased.png';
import globalicon from '../assets/hack4tts/global_icon.png';
import styleicon from "../assets/hack4tts/Icon.png";
import micicon from "../assets/hack4tts/mic.png";
import hindiicon from '../assets/hack4tts/hindi_logo.png';
import artparklogo from '../assets/hack4tts/artpark_logo.png';
import gizlogo from '../assets/hack4tts/giz_logo.png';
import bhashinilogo from '../assets/hack4tts/bhashini_logo.png';
import iisclogo from '../assets/hack4tts/iisc_logo.png';
import sammanlogo from '../assets/hack4tts/samman_logo.png';
import armmanlogo from '../assets/hack4tts/armman_logo.png';
import greenZap from "../assets/hack4tts/greenZap.png";
import Zap from "../assets/hack4tts/Zap.png";
import orangeZap from "../assets/hack4tts/orangeZap.png";
import smiley from "../assets/hack4tts/Smiley.png";
import avatar1 from "../assets/hack4tts/Avatar1.png";
import avatar2 from "../assets/hack4tts/Avatar2.png";
import avatar3 from "../assets/hack4tts/Avatar3.png";
import PrizeCupBronze from "../assets/hack4tts/PrizeCupBronze.png";
import PrizeCupGold from "../assets/hack4tts/PrizeCupGold.png";
import PrizeCupSilver from "../assets/hack4tts/PrizeCupSilver.png";
import IconWER from "../assets/hack4tts/downtrendgraph.png";
import IconCER from "../assets/hack4tts/graphIcon.png";
import IconMOS from "../assets/hack4tts/peopleIcon.png";
import IconTime from "../assets/hack4tts/clockicon.png";
import IconSize from "../assets/hack4tts/databaseicon.png";
import IconFlops from "../assets/hack4tts/activityIcon.png";
import DocIcon from '../assets/hack4tts/DocIcon.png';
import FAQicon from '../assets/hack4tts/FAQicon.png';
import ReferenceIcon from '../assets/hack4tts/ReferenceIcon.png';
import spirelogo from '../assets/hack4tts/spire_logo.png';
import hack4ttslogo from '../assets/hack4tts/Logo_no_Background.png';
import bengalilang from '../assets/hack4tts/bangla_lang.png';
import marathilang from '../assets/hack4tts/marathi_lang.png';
import telugulang from '../assets/hack4tts/telugu_lang.png';
import bhojpurilang from '../assets/hack4tts/bhojpuri_lang.png';
import hindilang from '../assets/hack4tts/hindi_lang.png';
import chhattisgarhilang from '../assets/hack4tts/chhattisgarhi_lang.png';
import kannadalang from '../assets/hack4tts/kannada_lang.png';
import magadhilang from '../assets/hack4tts/magadhi_lang.png';
import englishlang from '../assets/hack4tts/english_lang.png';
import gujaratilang from '../assets/hack4tts/gujarati_lang.png';
import maithililang from '../assets/hack4tts/maithili_lang.png';
import magahilang from '../assets/hack4tts/magahi_lang.png';
import timeline_r1 from '../assets/hack4tts/hack_timeline_img.png';
import hackbanner768 from '../assets/hack4tts/Hack_Banner768.png';

import hackbanner1280 from '../assets/hack4tts/Hack_Banner1280.png';
import hackbanner360 from '../assets/hack4tts/Hack_Banner360.png';
import startups from '../assets/hack4tts/startups.png';
import freelancer from '../assets/hack4tts/freelancer.png';
import industry from '../assets/hack4tts/industry.png';
import student from '../assets/hack4tts/student.png';
import final_event from '../assets/hack4tts/final_event.png'; 
import amithab_nag from '../assets/hack4tts/amitabh_nag.jpeg';
import philiph from '../assets/hack4tts/philip_o.jpg';
import kruthi_dalal from '../assets/hack4tts/kruthi_dalal.jpeg';
import hackeventbanner1280 from '../assets/hack4tts/Hack_Event_Banner1280.jpg';
import deekshitha from '../assets/hack4tts/deekshitha_g.png';
import jesuraj from '../assets/hack4tts/JesurajBandekar.jpg';
import pranav from '../assets/hack4tts/PranavDBhat.jpg';
import hackeventbannerlandscape from '../assets/hack4tts/Hack_Event_Bannerlandscape.png';
import hackeventbanner768 from '../assets/hack4tts/Hack_Event_Banner768.png';
import raghu_d from '../assets/hack4tts/raghu_d.jpeg';
import bharadwaj_a from '../assets/hack4tts/bharadwaj_a.png';
import winner_event from '../assets/hack4tts/winners_event.png';

// import galleryImg1 from '../assets/Gallery/gallery1.png'
// import galleryImg2 from '../assets/Gallery/gallery2.png'
// import galleryImg3 from '../assets/Gallery/gallery3.png'
// import galleryImg4 from '../assets/Gallery/gallery4.png'
// import galleryImg5 from '../assets/Gallery/gallery5.png'
// import galleryImg6 from '../assets/Gallery/gallery6.png'
// import galleryImg7 from '../assets/Gallery/gallery7.png'
// import galleryImg8 from '../assets/Gallery/gallery8.png'
// import galleryImg9 from '../assets/Gallery/gallery9.png'
// import galleryImg10 from '../assets/Gallery/gallery10.png'
// import galleryImg11 from '../assets/Gallery/gallery11.png'
// import galleryImg12 from '../assets/Gallery/gallery12.png'
// import galleryImg13 from '../assets/Gallery/gallery13.png'
// import galleryImg14 from '../assets/Gallery/gallery14.png'
// import galleryImg15 from '../assets/Gallery/gallery15.png'
    // import video  from '../assets/Gallery/Video/Syspin_video.mp4'
// import bhashiniimg1 from '../assets/Gallery/Bhashini/Bhashini_1.jpg'
// import bhashiniimg2 from '../assets/Gallery/Bhashini/Bhashini_2.jpg'
// import bhashiniimg3 from '../assets/Gallery/Bhashini/Bhashini_Office.jpg'
// import gizmeeting_1 from '../assets/Gallery/FunderMeeting/Funding_team.jpg'

import spiremap from '../assets/staticmap.png';

const application_contants = {
    BGPATHIMG: bgPath,
    CIRCLEPATHIMG: circlePath,
    IISCLOGOIMG: iiscLogo,
    SPARELABIMG: spareLab,
    MOBILEPATH: mobilePath,
    LOGOIMG: logo,
    PARTNERIMG: PartnerImg,
    FFLOGO:FFLogo,
    GGICIMG: GGICImg,
    EMAILIMG: EmailImg,
    LOCATIONIMG: LocationImg,
    DOWNARROW: DownArrow,
    UPARROW: UpArrow,
    MENUIMG: MenuImg,
    CLOSEIMG: CloseImg,
    MENULOGO: Menulogo,
    SYSPIN: Syspin,
    DASH: Dash,
    IISCImg: IISCImg,
    rightImg: rightImg,
    RIGHTARROW: rightarrow,
  //   galleryImg1 : galleryImg1,
  // galleryImg2 : galleryImg2,
  // galleryImg3 : galleryImg3,
  // galleryImg4 : galleryImg4,
  // galleryImg5 : galleryImg5,
  // galleryImg6 : galleryImg6,
  // galleryImg7 : galleryImg7,
  //  galleryImg8 : galleryImg8,
  //  galleryImg9 : galleryImg9,
  //  galleryImg10 : galleryImg10,
  //  galleryImg11 : galleryImg11,
  //  galleryImg12 : galleryImg12,
  //  galleryImg13 : galleryImg13,
  //  galleryImg14 : galleryImg14,
  //  galleryImg15 : galleryImg15,
  //  bhashiniimg1 : bhashiniimg1,
  //  bhashiniimg2 : bhashiniimg2,
  //  bhashiniimg3 : bhashiniimg3,
  //  gizmeeting_1 : gizmeeting_1,
        //  video : video, 

  spiremap : spiremap,
  
    LANDING: '/',
    LOGIN: '/login',
    ABOUTUS: '/aboutUs',
    PEOPLES: '/people-list',
    PARTNERLIST: '/partner-list',
    BANNERLIST: '/banner-list',
    OPENINGLIST: '/opening-list',
    CHALLENGESLIST: '/challenges-list',
    REASEARCHAREA : '/researcharea-list',
    DOCUMENTS : '/documents-list',
    MEDIA : '/Media-list',
    CONTRIBUTORS : '/Contributors-list',
    PUBLICATION : '/publications-list',
    INDIVIDUALS : '/individuals-list',
    EXPERTS : '/Expert-List',
    ACADEMICS : '/academics-list',
    INDUSTRY : '/industry-list',
    BANNER : '/banner-list',
    DATASETS: '/datasets-list',
    TOOLLIST: '/tool-list',
    MOBILE_BREAKPOINT: 1023,

    styleicon: styleicon,
    micicon: micicon,
    globalicon: globalicon,
    hindiicon: hindiicon,
    artparklogo: artparklogo,
    gizlogo: gizlogo,
    bhashinilogo: bhashinilogo,
    iisclogo: iisclogo,
    sammanlogo: sammanlogo,
    smiley: smiley,
    greenZap: greenZap,
    Zap: Zap,
    orangeZap: orangeZap,
    avatar1: avatar1,
    avatar2: avatar2,
    avatar3: avatar3,
    PrizeCupBronze: PrizeCupBronze,
    PrizeCupGold: PrizeCupGold,
    PrizeCupSilver: PrizeCupSilver,
    IconWER: IconWER,
    IconCER: IconCER,
    IconMOS: IconMOS,
    IconTime: IconTime,
    IconSize: IconSize,
    IconFlops: IconFlops,
    DocIcon: DocIcon,
    FAQicon: FAQicon,
    ReferenceIcon: ReferenceIcon,
    spirelogo: spirelogo,
    armmanlogo: armmanlogo,
    hack4ttslogo: hack4ttslogo,
    bengalilang: bengalilang,
    marathilang: marathilang,
    telugulang: telugulang,
    bhojpurilang: bhojpurilang,
    hindilang: hindilang,
    chhattisgarhilang: chhattisgarhilang,
    kannadalang: kannadalang,
    magadhilang: magadhilang,
    magahilang: magahilang,
    englishlang: englishlang,
    gujaratilang: gujaratilang,
    maithililang: maithililang,
    timeline_r1: timeline_r1,
    hackbanner1280:hackbanner1280,
    hackbanner360:hackbanner360,
    hackbanner768:hackbanner768,
    Datareleased: Datareleased,
    Modelreleased: Modelreleased,
    student: student,
    startups : startups,
    freelancer:freelancer,
    industry:industry,
    final_event: final_event,
    amithab_nag: amithab_nag,
    philiph: philiph,
    kruthi_dalal: kruthi_dalal,
    hackeventbanner1280: hackeventbanner1280,
    deekshitha: deekshitha,
    jesuraj: jesuraj,
    pranav: pranav,
    hackeventbanner768: hackeventbanner768,
    hackeventbannerlandscape: hackeventbannerlandscape,
    raghu_d: raghu_d,
    bharadwaj_a: bharadwaj_a,
    winner_event: winner_event,

};

export default application_contants;